import { useAtomValue } from 'jotai';

import useHandleResizedImage from '../../../../../hooks/useHandleResizedImage';
import { currentPageAtom } from '../../../../../store/index.atom';
import DesktopHyperLinkLayer from '../../HyperLinkLayer/Desktop';
import {
  MessageBoxItemType,
  PdfViewerRedirect,
} from '../../../../PdfViewer/index.types';
import MessageBoxLayer from '../../MessageBoxLayer';

export interface DesktopAnnotationLayerProps {
  isPreview?: boolean;
  thumnail: PdfViewerRedirect['thumnail'];
  messageBoxItems?: MessageBoxItemType[];
}

const DesktopAnnotationLayer = ({
  thumnail,
  isPreview = false,
  messageBoxItems,
}: DesktopAnnotationLayerProps) => {
  const currentPage = useAtomValue(currentPageAtom);

  const { hyperlink, originalWidth, originalHeight } =
    thumnail[currentPage - 1];

  const { resizedImageSize } = useHandleResizedImage({
    originalHeight,
    originalWidth,
  });

  if (!thumnail) {
    return null;
  }

  return (
    <>
      <MessageBoxLayer
        resizedImageSize={resizedImageSize}
        isPreview={isPreview}
        messageBoxItems={messageBoxItems}
      />
      <DesktopHyperLinkLayer
        hyperlinkList={hyperlink}
        resizedImageSize={resizedImageSize}
        isPreview={isPreview}
      />
    </>
  );
};

export default DesktopAnnotationLayer;
